import { render } from "./TheItem.vue?vue&type=template&id=5e27072d"
import script from "./TheItem.vue?vue&type=script&lang=js"
export * from "./TheItem.vue?vue&type=script&lang=js"

import "./TheItem.vue?vue&type=style&index=0&id=5e27072d&lang=scss"
script.render = render

export default script